import { createUseStyles } from 'react-jss';

import { PricingAppTheme } from '~app/styles/pricing/types';

const useHubSpotStyles = createUseStyles<string, {}, PricingAppTheme>(({ spacing }) => ({
  CheckBoxWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: spacing[2],
    '& p': {
      overflowX: 'clip',
    },
  },
}));

export default useHubSpotStyles;
